<div class="host ___dashboard page" *ngIf="page$ | async as page; else loadingView">
  <div class="main" *ngIf="page.ok; else notFound">
  <ng-container *ngIf="data$ | async; let data">
  <ng-container *ngIf="!query ? data.folderItems : (data.searchItems || data.folderItems); let listingItems;">
  <ng-container *ngIf="listingItems | mediaTypeFilter : type | paginate : { itemsPerPage: 30, currentPage: pageNo }; let activeItems;">

    <div class="head">
  
      <div class="title">
        <h1>Media</h1>
        <button
          class="button-outline-primary"
          (click)="showUploader=true"
        >Add New</button>
      </div>
  
      <ul class="types" *ngIf="listingItems | mediaExtractTypes as listingTypes">
        <ng-container *ngFor="let listingType of listingTypes">
          <li *ngIf="listingType.count">
            <strong *ngIf="listingType.value === type; else inactiveType">{{ listingType.title }}</strong>
            <ng-template #inactiveType>
              <a href="#" (click)="type=listingType.value; false">{{ listingType.title }}</a>
            </ng-template>
            <em>({{ listingType.count }})</em>
          </li>
        </ng-container>
      </ul>
  
    </div>
  
    <div class="body">
      
      <ng-template #listingBar>
        <div class="folders">
          <select class="form-select" (change)="changeFolder($event)">
            <option value="0" selected disabled>Select folder</option>
            <option
              *ngFor="let folder of data.folders"
              [selected]="activeFolder===folder"
              [value]="folder"
            >{{ folder || '/' }}</option>
          </select>
        </div>
        <div class="search">
          <input
            class="form-control"
            type="search"
            placeholder="Search files by name ..."
            [(ngModel)]="query"
            (keyup.enter)="search(data.searchQuery)"
          >
          <button class="button-primary" (click)="search(data.searchQuery)" [disabled]="!query">Search</button>
        </div>
        <div class="layouts">
          <button [class.active]="layout==='list'" (click)="layout='list'">
            <i class="icon-medium-tint icon-dashboard-layout-list"></i>
          </button>
          <button [class.active]="layout==='thumbnail'" (click)="layout='thumbnail'">
            <i class="icon-medium-tint icon-dashboard-layout-thumbnail"></i>
          </button>
        </div>
        <div class="counter">{{ activeItems.length }} items</div>
      </ng-template>
  
      <div class="headbar">
        <ng-container *ngTemplateOutlet="listingBar"></ng-container>
      </div>
  
      <div class="major">
  
        <table class="listing list table-striped" *ngIf="layout==='list'; else thumbnailLayout;">
  
          <thead>
            <tr>
              <th class="name">Name</th>
              <th class="size">Size</th>
              <th class="type">Type</th>
              <th class="date">Date</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngIf="isListingLoading">
              <td colspan="42">
                <div class="loading">
                  <nguix-dashboard-spinner></nguix-dashboard-spinner>
                </div>
              </td>
            </tr>            
            <tr *ngIf="!isListingLoading && !activeFolder && !(query && data.searchItems)">
              <td colspan="42">Select an folder or search to view files.</td>
            </tr>
            <tr *ngIf="query && data.searchItems">
              <td colspan="42">Currently view top search result for query "<strong>{{ data.searchQuery }}</strong>", <a href="#" (click)="query=''; false;">clear search</a>.</td>
            </tr>
            <tr *ngFor="let listingItem of activeItems">
              <td class="name">
                <a href="#" (click)="detailItem=listingItem; false;">
                  <i class="icon-medium" [class]="'icon-dashboard-media-' + listingItem.type"></i>              
                  <strong>{{ listingItem.name }}</strong>
                </a>
              </td>
              <td class="size">{{ listingItem.metadata.size | filesize }}</td>
              <td class="type">{{ listingItem.metadata.contentType }}</td>
              <td class="date">{{ listingItem.metadata.updated | date }}</td>
            </tr>
          </tbody>
  
          <tfoot>
            <tr>
              <td colspan="42">
                <pagination-controls
                  (pageChange)="pageNo=$event"
                  [directionLinks]="false"
                ></pagination-controls>
              </td>
            </tr>
          </tfoot>
  
        </table>
  
        <ng-template #thumbnailLayout>
          <ul class="listing thumbnail">
            <li class="loading" *ngIf="isListingLoading">
              <nguix-dashboard-spinner></nguix-dashboard-spinner>
            </li>
            <li class="not-item" *ngIf="!isListingLoading && !activeFolder && !(query && data.searchItems)">
              Select an folder or search to view files.
            </li>
            <li class="not-item" *ngIf="query && data.searchItems">
              Currently view top search result for query "<strong>{{ data.searchQuery }}</strong>", <a href="#" (click)="query=''; false;">clear search</a>.
            </li>
            <li *ngFor="let listingItem of activeItems">
              <a
                class="file-thumbnail"
                href="#"
                (click)="detailItem=listingItem; false;"
                [style.background-image]="
                  listingItem.type !== 'image'
                    ? null
                    : 'url(' + listingItem.downloadUrl + ')'
                "
              >
                <span *ngIf="listingItem.type!=='image'">
                  <i class="icon-medium" [class]="'icon-dashboard-media-' + listingItem.type"></i>
                </span>
              </a>
              <a class="file-name" href="#" (click)="detailItem=listingItem; false;">{{ listingItem.name }}</a>
              <div class="file-info">
                <span>{{ listingItem.metadata.updated | date }}</span>
                <span>{{ listingItem.metadata.size | filesize }}</span>
              </div>
            </li>
          </ul>
        </ng-template>
  
        <div class="detail" [class.show]="detailItem" *ngIf="detailItem">
          <div class="top">
            <div class="title">
              <i class="icon-medium" [class]="'icon-dashboard-media-' + detailItem.type"></i>
              <strong>{{ detailItem.name }}</strong>
            </div>
            <a href="#" (click)="detailItem=undefined;false;">X</a>
          </div>
          <div class="content">
            <div class="view">
              <img *ngIf="detailItem.type==='image'" [src]="detailItem.downloadUrl" [alt]="detailItem.name">
              <audio *ngIf="detailItem.type==='audio'" controls [src]="detailItem.downloadUrl"></audio>
              <video *ngIf="detailItem.type==='video'" controls [src]="detailItem.downloadUrl"></video>
            </div>
            <div class="name">
              <span>Name</span>
              <strong>
                <a [href]="detailItem.downloadUrl" target="_blank">{{ detailItem.name }}</a>
              </strong>
            </div>
            <div class="path"><span>Path</span><strong>{{ detailItem.fullPath }}</strong></div>
            <div class="size"><span>Size</span><strong>{{ detailItem.metadata.size | number }} bytes</strong></div>
            <div class="type"><span>Type</span><strong>{{ detailItem.metadata.contentType }}</strong></div>
            <div class="created"><span>Created</span><strong>{{ detailItem.metadata.timeCreated | date }}</strong></div>
            <div class="updated"><span>Updated</span><strong>{{ detailItem.metadata.updated | date }}</strong></div>
            <div class="actions">
              <button class="button-danger-sm" (click)="delete(detailItem)">Delete</button>
            </div>
          </div>
        </div>
  
      </div>
      
      <div class="footbar">
        <ng-container *ngTemplateOutlet="listingBar"></ng-container>
      </div>
  
    </div>

  </ng-container>
  </ng-container>
  </ng-container>
  </div>

  <ng-template #notFound>
    <div class="not-found">Not found ...</div>
  </ng-template>

</div>

<ng-template #loadingView>
  <div class="loading">
    <nguix-dashboard-spinner></nguix-dashboard-spinner>
  </div>
</ng-template>

<nguix-dashboard-uploader [show]="showUploader" (close)="showUploader=false"></nguix-dashboard-uploader>
